module.exports = __webpack_public_path__ + "img/undraw_town_r6pc.8c443bd9.svg";